import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ROUTES = {
  "/": {
    title: "ChippyMate - Offcut | The Ultimate Building App",
    description:
      "Offcut by ChippyMate — building formulas, digital logbooks, drafting tools and ever-evolving features to help tradies work smarter, faster, more efficient.",
  },
  "/about": {
    title: "About | ChippyMate - Offcut",
    description:
      "Everything you need to build, create, and get the job done. The story behind Offcut by ChippyMate — built by tradies, for tradies.",
  },
  "/pricing": {
    title: "Pricing | ChippyMate - Offcut",
    description:
      "Offcut subscription plans in AUD incl. GST — Pro, Premium Team and Ultimate Team, monthly or yearly. Cancel anytime.",
  },
  "/terms": {
    title: "Terms & Conditions | ChippyMate - Offcut",
    description:
      "Terms and Conditions and Acceptable Use Policy for the Offcut app by ChippyMate.",
  },
  "/acceptable-use": {
    title: "Acceptable Use Policy | ChippyMate - Offcut",
    description:
      "Acceptable Use Policy for the Offcut app by ChippyMate — keeping the Services safe, reliable and fair for everyone.",
  },
  "/privacy": {
    title: "Privacy Policy | ChippyMate - Offcut",
    description:
      "How ChippyMate - Offcut collects, uses and protects your personal information.",
  },
  "/account-deletion": {
    title: "Account Deletion | ChippyMate - Offcut",
    description:
      "How to delete your Offcut account, what happens to your information, and the 30-day recovery period.",
  },
  "/contact": {
    title: "Contact Us | ChippyMate - Offcut",
    description:
      "Get in touch with the ChippyMate - Offcut team — questions, feedback or feature ideas.",
  },
};

export default function Seo() {
  const { pathname } = useLocation();

  useEffect(() => {
    const route = ROUTES[pathname] || ROUTES["/"];
    document.title = route.title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", route.description);
  }, [pathname]);

  return null;
}
